<template>
  <div class="mb-4">
  <div class="d-flex agent-content-area">
        <div class="align-items-top">
<div class="agent-area d-flex" >
  <div class="type-img d-flex align-items-center" >
          <b-button variant="basic"  v-if="agent.id" class="mr-2 mb-2 pr-3 pl-3 pb-2 pt-2" @click="toggleShowQR(true)">
          <i :class="'fas fa-qrcode'"></i>
        </b-button>

        <b-button variant="basic" v-if="agent.id" class="mr-2 mb-2 pr-3 pl-3 pb-2 pt-2" @click="toggleShowQR(false)">
          <i :class="'fas fa-user'"></i>
        </b-button>
      </div>
      <div class="d-flex" style="flex-direction: column;">
          <b-img width="300px" v-if="!showQRImage" :src="this.agentImage" style="border:1px dashed gray; background-color: #FFF;" class="text-center">
          </b-img>
          <qrcode-vue v-if="showQRImage" :renderAs="'svg'" :class="'svg'" :size="300" :value="getWindowOrigin + '/profile/' + agent.uuid">
          </qrcode-vue>
          <div v-if="agent.id && !isMobile" class="btn btn-success mt-3" @click="copyTextToClipboard(getWindowOrigin + '/profile/' + agent.uuid + '/')">
          <i class="fas fa-copy"></i> COPIAR LINK DA CARTEIRA
          </div>
        </div>
        </div>


          <div v-if="mainPlaceAgentData['changed']['value']" class="text-right">
      <sub>
        atualizado em {{ new Date(mainPlaceAgentData['changed']['value']).toLocaleDateString() }}
        <i class="fas fa-clock" title="data da última atualização do cadastro"> </i>
      </sub>
    </div>
    <b-row>
        <b-button v-if="agent.id && isMobile" class="mr-2 pt-2 pb-2 pl-3 pr-3" @click="share({
            title: 'Carteira Digital de Condutor',
            text: `${agent.name}${agent.nickname != null ? ` - ${agent.nickname.trim()}` : ''}`,
            url: getWindowOrigin + '/profile/' + agent.uuid,
          })">
          <i class="fas fa-share"></i>
        </b-button>
    </b-row>
        </div>

    <div class="info-agent-area">
      <!--
      <b-row>
        <b-col>
          <div class="card-profile-stats d-flex justify-content-center">
             <div>
              <span class="heading">22</span>
              <span class="description">Friends</span>
            </div>
            <div>
              <span class="heading">10</span>
              <span class="description">Photos</span>
            </div>
            <div>
              <span class="heading">89</span>
              <span class="description">Comments</span>
            </div>
          </div>
        </b-col>
      </b-row>-->
      <div style="font-size: 22px; font-weight: bold; color: black;">{{ agent.nickname != null ? agent.nickname.trim() : '--' }}</div>
      <div style="font-size: 18px; font-weight: 600; color: black;">  {{ agent.name }}</div>

        <!-- <h4 class="text-right">
          <small>autorizado: <b><a href="https://janoo.com.br/lugar/cachoeira-do-buracao/" target="_blank"
                style="color:rgb(233 68 151)">Cachoeira do Buracão</a></b>
          </small>
        </h4> -->

      <div v-if="!isAgentActive" class="text-center">
        <span class="text-warning">
          Cadastro desativado
        </span>
      </div>

      <div v-if="isAgentActive" class="pt-3">
        <!-- <div>
          Categoria: <span v-show="agent.category"> {{agent.category}}</span>
        </div> -->
        <!-- <div v-if="mainPlaceAgentData.active">
          Ativo: <span > {{isAgentActive?"Sim":"Não"}}</span>
        </div> -->
          <!-- <div>
            Código:
            <small>{{ agent['uuid'] }}</small>
          </div> -->
          <div>
          <div class="d-flex align-items-center pb-3">
            <i class="no no-user pr-2" style="color: black;"></i>
            <div  style="font-weight: 600; color: black;" v-if="place.name">{{ place.name }}</div>
            <small v-else> Não informado</small>
          </div>
        </div>

<div class="d-flex info-inside-agent">
  <div class="pr-5">
    <div>
          <div class="d-flex align-items-center pt-2">
            <i class="no no-present-3 pr-2" style="color: black;"></i>
            <div style="color: black;" v-if="mainPlaceAgentData['birthday'] && mainPlaceAgentData['birthday']['value']">{{
              mainPlaceAgentData['birthday']['value'] | toLocaleBirthDate }}</div>
            <small v-else> Não informado</small>
          </div>


          <div class="d-flex align-items-center pt-2">
            <i class="no no-translation-3 pr-2" style="color: black;"></i>
            <div style="color: black;" v-if="undefined != mainPlaceAgentData['languages'] && undefined != mainPlaceAgentData['languages']['value']">
              {{ mainPlaceAgentData.languages && mainPlaceAgentData.languages.value &&
                Object.prototype.toString.call(mainPlaceAgentData.languages.value) == '[object Array]' ?
                mainPlaceAgentData.languages.value.map((lang) => { return lang.label || lang }).join(', ') : "nenhum"
              }}
            </div>
            <small v-else>Não informado</small>
          </div>


          <div class="d-flex align-items-center pt-2">
            <i class="no no-drop-3 pr-2" style="color: black;"></i>
            <div style="color: black;" v-if="mainPlaceAgentData['blodtype'] && mainPlaceAgentData['blodtype']['value']">{{
              mainPlaceAgentData['blodtype']['value']['value'] }}</div>
            <small v-else>Não informado</small>
          </div>

          <div class="d-flex align-items-center pt-2">
            <i class="no no-position-marker pr-2" style="color: black;"></i>
            <div style="color: black;" v-if="city.name">
            {{ mainPlaceAgentData.address_city?mainPlaceAgentData.address_city.value:city.name }}
            </div>
            <small v-else>
             não informado
            </small>
          </div>

          <!-- <div>
            E-mail:
            <small v-if="undefined != mainPlaceAgentData['mailaddress'] && mainPlaceAgentData['mailaddress']['value']"> <a
                target="_blank" :href="`mailto:${mainPlaceAgentData['mailaddress']['value']}`">{{
                  mainPlaceAgentData['mailaddress']['value']
                }}</a></small>
            <small v-else> não informado</small>
          </div> -->

          <div class="d-flex align-items-center pt-2">
            <i class="no no-whatsapp pr-2" style="color: black;"></i>
            <div style="color: black;" v-if="undefined != mainPlaceAgentData['mobile'] && mainPlaceAgentData['mobile']['whatsapp']">
           <a :href="`${mainPlaceAgentData['mobile']['whatsapp']}`">{{ mainPlaceAgentData['mobile']['value'] }}</a>
            </div>

            <small v-else>
              <a v-if="undefined != mainPlaceAgentData['mobile'] && mainPlaceAgentData['mobile']['value']" :href="`tel:${mainPlaceAgentData['mobile']['value']}`">
                {{ mainPlaceAgentData['mobile']['value'] }}
              </a>
              <span v-else>não informado</span>
            </small>
          </div>
        </div>

        </div>
          <!-- <div v-if="undefined != mainPlaceAgentData['Telefone'] && mainPlaceAgentData['Telefone']['value']">
            Telefone:
            <small> {{ mainPlaceAgentData['Telefone']['value'] }}</small>
          </div> -->

          <div style="color: black;" class="pt-2">
          Carteira de Motorista:
            <small v-if="undefined != mainPlaceAgentData['cnh'] && undefined != mainPlaceAgentData['cnh']['value']"> {{
              mainPlaceAgentData.cnh.value.label ? mainPlaceAgentData.cnh.value.label : (mainPlaceAgentData.cnh.value ?
                mainPlaceAgentData.cnh.value : "não possui") }}</small>
            <small v-else> não informado</small>




          <div>
            Cursos e Habilidades:
            <ul v-if="Object.keys(formationItems).length">
              <li v-for="formation in Object.values(formationItems)" :key="formation.id"><small>
                  {{ formation.name }} | {{ formation.date.substring(0, 4) }}</small></li>
            </ul>
            <small v-else> não informado </small>
          </div>
        </div>
      </div>




          <div v-if="undefined != mainPlaceAgentData.active_pois && undefined != mainPlaceAgentData.active_pois.value && Object.keys(mainPlaceAgentData.active_pois.value).length">
            Condutor autorizado:
            <small v-if="!showAllActivePois">
              {{ Object.values(mainPlaceAgentData.active_pois.value).map((poi) => { return poi.label }).slice(0,3).join(' | ') }}
            </small>

            <small v-if="!showAllActivePois" @click="showAllActivePois = !showAllActivePois" title="ver todos as autorizações" style="cursor:pointer">
              <!-- <i class="fas fa-plus text-primary"></i> -->
              <span class="text-primary font-size-4">
                [ver +{{ Object.keys(mainPlaceAgentData.active_pois.value).length - 3 }}]
              </span>
            </small>

            <small v-if="showAllActivePois" @click="showAllActivePois = !showAllActivePois" title="ver todos as autorizações" style="cursor:pointer">
              <span class="text-primary font-size-4">
                [ocultar]
              </span>
            </small>

            <div style="max-width:100%;overflow-x: auto;" v-if="showAllActivePois">
              <ul v-if="undefined != mainPlaceAgentData.active_pois.value && Object.keys(mainPlaceAgentData.active_pois.value).length" style="width:max-content;overflow-x: auto;">
                <li v-for="(poi) in Object.values(mainPlaceAgentData.active_pois.value).map((poi) => { return poi.label })" :key="poi">
                  <small>{{ poi }}</small>
                </li>
              </ul>
              <small v-else> -- </small>
            </div>
          </div>
      </div>
    </div>

 <!--   <b-card-footer v-if="agent.id">
      <b-img style="width:100%; max-height: 50px;" class="text-center" v-if="this.placeImage" :src="this.placeImage">
      </b-img>
       <a href="//janoo.com.br">
        <b-img class="col-md-12 card pb" :src="getPlaceLogotipo" xrounded="circle" />
      </a>
    </b-card-footer>-->


  </div>
</div>
</template>

<script>
import qrcodeVue from "qrcode.vue"
import bocapioService from "@/services/nodejs/index"
export default {
  components: {
    qrcodeVue
  },

  name: 'agent-card',

  props: {
    agent: {
      type: Object,
      default: () => {},
    },

    formations: {
      type: Array,
      default: () => [],
    },

    city: {
      type: Object,
      default: () => {},
    },

    place: {
      type: Object,
      default: () => {},
    },

    mainPlaceAgentData: {
      type: Object,
      default: () => {},
    },

    toggleQR: {
      type: Boolean,
      default: false
    },
  },

  data() {
    return {
      formationItems: [],
      showQRImage: false,
      agentImage: 'img/theme/backpacker.png',
      placeImage: false,
      isAgentActive: false,
      showAllActivePois: false,
    }
  },

  created() {
    this.isAgentActive = this.mainPlaceAgentData.active != undefined && this.mainPlaceAgentData.active.value === 'true'
    this.loadAgentImage()
    if (this.agent.id) {
      this.loadPlaceImage()
      this.loadAgentFormations()
    }
  },

  methods: {
    toggleShowQR(value) {
      if(value != undefined){
        this.showQRImage = value

      }else{
        this.showQRImage = !this.showQRImage

      }
    },

    loadAgentImage() {
      if (this.agent.id) {
        bocapioService.getFileByPath(this.agent.images)
          .then(rsp => {
            var blob = new Blob([rsp.data], { type: rsp.data.type })
            this.agentImage = URL.createObjectURL(blob)
          })
      }
    },

    loadPlaceImage() {
      try {
        let src = `${this.getPlace().xfields.Logotipo.value.filepath}${this.getPlace().xfields.Logotipo.value.name}`
        bocapioService.getFileByPath(src)
          .then(rsp => {
            var blob = new Blob([rsp.data], { type: rsp.data.type })
            this.placeImage = URL.createObjectURL(blob)
          })
      } catch (error) { }
    },

    loadAgentFormations() {
      this.formationItems = {}
      this.formations.forEach((formation) => {
        var value = formation.Formation.name.toUpperCase().replace(/[^A-Z]+/g, '')
        if (this.formationItems[value] == undefined || formation.Formation.date > this.formationItems[value]['date']) {
          this.formationItems[value] = formation.Formation
        }
      })
    },

    share(data) {
      if (!navigator.share) {
        let type = "error"
        this.$notify({
          message: 'Erro ao tentar compartilhar',
          duration: 6000,
          type
        })
      } else {
        navigator.share(data)
          .then()
          .catch((error) => console.log('Error ao tentar compartilhar', error))
      }
    },

    copyTextToClipboard(text) {
      if (!navigator.clipboard) {
        let type = "error"
        this.$notify({
          message: 'Erro ao copiar o texto para área de transferência',
          duration: 6000,
          type
        })
        return;
      }
      navigator.clipboard.writeText(text).then(() => {
          let type = "default"
          this.$notify({
            message: 'Link da carteira copiado!',
            duration: 5000,
            //icon: "ni ni-bell-55",
            type
          })
        }
      )
    },

    getPlace() {
      return this.place;
    },
  },

  computed: {
    getWindowOrigin() {
      return window.location.origin
    },

    isMobile() {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) { return true }
      else { return false }
    },
  },

  filters: {
    toLocaleBirthDate(strBirthDate) {
      let birthDate = new Date(strBirthDate + ' 12:00:00')
      if (isNaN(birthDate.getTime())) {
        strBirthDate = strBirthDate.split('/')
        birthDate = new Date(strBirthDate[2], strBirthDate[1] / 1 - 1, strBirthDate[0])
      }
      let localeStrBirthDate = ''
      if (!isNaN(birthDate.getTime())) {
        localeStrBirthDate += ('0' + birthDate.getDate()).slice(-2)
        localeStrBirthDate += ' de '
        localeStrBirthDate += birthDate.toLocaleString('default', { month: 'long' })
      } else {
        localeStrBirthDate = false
      }
      return localeStrBirthDate
    },

    age(birthDate) {
      var today = new Date()
      var _age = '--'
      if (birthDate.indexOf('/') > 0) {
        birthDate = birthDate.split('/')
        birthDate = new Date(birthDate[2] + '-' + birthDate[1] + '-' + birthDate[0])
        _age = today.getFullYear() - birthDate.getFullYear()

      } else if (birthDate.indexOf('-') > 0) {
        birthDate = new Date(birthDate)
        _age = today.getFullYear() - birthDate.getFullYear()
      } else {
        birthDate = new Date()
      }
      var m = today.getMonth() - birthDate.getMonth()
      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        _age--
      }
      return `${_age} anos`
    },
  },

}
</script>
<style>
.viewagentmodal {
  display: flex;
}

.modal-xl{
  max-width: 70vw;
}

.type-img{
flex-direction: column;
}

.agent-content-area {
  align-items: flex-start;
  justify-content: center;
}

.agent-area {
  align-items: flex-start;
}

.info-agent-area {
  padding-left: 40px;
  padding-right: 40px;
}

@media screen and (max-width: 900px) {
.agent-content-area {
flex-direction: column;
align-items: center;
}

.type-img {
  flex-direction: row;
}

.agent-area {
  flex-direction: column;
  justify-content: center;
}

.info-agent-area {
  flex-direction: column;
  padding-left: 40px;
  padding-right: 40px;
}

.info-inside-agent {
  flex-direction: column;
}
}


@media screen and (max-width: 600px) {

.modal-xl {
  max-width: 95vw;

}
}
</style>
